export const vegetarischeSchupfnudeln  = {
	name: 'Vegetarische Schupfnudelpfanne mit Gemüse und Pilzen',
	desc: 'Kräuterquark Dip, bunter Paprikasalat und dazu Tagesdessert Joghurt im Becher',
	image: 12,
	benefits: [
		'Vegetarisch',
		'Viel Kalium, Magnesium, Zink und Calcium',
	],
	opinions: [
		{
			name: 'Mareike Mann',
			date: '17. März 2017',
			title: 'Sehr lecker',
			content: 'Hat mir wie immer gut geschmeckt. Lieber Gruß an die Leute die da kochen ;)',
			rating: 5,
		},
	],
	warnings: ['gluten'],
	ingredients: [
		{'Schupfnudeln': 'gluten'},
		'Olivenöl',
		'Lauch',
		'Pilze',
		'Salz',
		'Pfeffer',
	],
};



// WEBPACK FOOTER //
// ./src/dishes/single-dishes/vegetarischeSchupfnudeln.js